import {useNavigate} from 'react-router-dom';
import {useToggle} from '@mantine/hooks';


import {
    AiOutlineEdit,
    AiOutlineProfile
} from 'react-icons/ai';
import {IconContext} from 'react-icons';
import {
    FlexiButton,
    FlexiCancelButton
} from "@flexinet/ui-components";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {EditButton} from "../buttons/EditButton.tsx";
import {StartExecutionButton} from "../../executions/buttons/StartExecutionButton.tsx";
import {Playbook} from "../types.ts";

export const useEditPageTools = (playbook?: Playbook) => {

    const navigate = useNavigate();

    const {allowedActions} = useVerifiedPermissions()

    const [mode, toggle] = useToggle(['view', 'edit']);

    const tools = [];

    if (mode === 'view' && playbook?.id && allowedActions.includes('ExecutePlaybook')) {
        tools.push(
            <StartExecutionButton
                key={'start-execution'}
                variant={'filled'}
                playbookId={playbook.id}
                playbookName={playbook.name}
            />,
        );
    }


    if (allowedActions.includes('UpdatePlaybook')) {

        if (mode === 'edit') {
            tools.push(<FlexiButton variant={'filled'} key={'profile'}
                                    leftSection={<IconContext.Provider value={{size: '24px'}}>
                                        <AiOutlineProfile/></IconContext.Provider>}
                                    onClick={() => toggle()}>Profile</FlexiButton>);
        } else {
            tools.push(<EditButton leftSection={<AiOutlineEdit/>} variant={'filled'}
                                   key={'edit'}>Edit</EditButton>);
            // tools.push(<FlexiButton leftSection={<AiOutlineEdit/>} variant={'filled'} key={'edit'}
            //                         onClick={() => toggle()}>Edit</FlexiButton>);
        }

    }

    tools.push(<FlexiCancelButton key={'close'}
                                  onClick={() => navigate(`/playbooks`)}/>);


    return {
        mode,
        tools,
    };

};
